import React, { useEffect, useState } from "react";
import { Button, Form, Input } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  loginUserThunk,
  selectUser,
} from "AppStore/Slices/UserSlice/UserSlice";
import { useNavigate } from "react-router";

export const LoginForm = () => {
  const { isLoading, isAuth } = useSelector(selectUser);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [form] = Form.useForm();
  const [userLoginData, setUserLoginData] = useState({
    email: "",
    password: "",
  });
  useEffect(() => {
    if (isAuth) {
      navigate("/");
    }
  }, [isAuth]);

  const onFinish = async () => {
    dispatch(loginUserThunk(userLoginData));
  };
  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      requiredMark={false}
    >
      <Form.Item
        name="email"
        rules={[
          {
            required: true,
            message: "Введіть email",
          },
          {
            type: "email",
            message: "Некоректний email",
          },
        ]}
      >
        <Input
          value={userLoginData.email}
          onChange={(e) => {
            setUserLoginData((prev) => {
              prev.email = e.target.value.toLowerCase().trim();
              return prev;
            });
          }}
          size="large"
          prefix={<UserOutlined />}
          placeholder="Email"
        />
      </Form.Item>

      <Form.Item
        name="password"
        value={userLoginData.password}
        onChange={(e) => {
          setUserLoginData((prev) => {
            prev.password = e.target.value;
            return prev;
          });
        }}
        rules={[
          {
            required: true,
            message: "Введіть пароль",
          },
          {
            min: 10,
            message: "Пароль має містити мінімум 10 символів",
          },
        ]}
      >
        <Input.Password
          size="large"
          prefix={<LockOutlined />}
          placeholder="Пароль"
        />
      </Form.Item>

      <Form.Item style={{ marginTop: 6, marginBottom: 0 }}>
        <Button
          htmlType="submit"
          type="primary"
          size="large"
          block
          loading={isLoading}
        >
          Увійти
        </Button>
      </Form.Item>
    </Form>
  );
};
